<div class="filter-container">
  <button
    nz-button
    [nzType]="activePeriod === 'hours' ? 'primary' : 'default'"
    (click)="setActivePeriod('hours')"
  >
    по часам
  </button>
  <button
    nz-button
    [nzType]="activePeriod === 'days' ? 'primary' : 'default'"
    (click)="setActivePeriod('days')"
  >
    по дням
  </button>
  <button
    nz-button
    [nzType]="activePeriod === 'weeks' ? 'primary' : 'default'"
    (click)="setActivePeriod('weeks')"
  >
    по неделям
  </button>
  <button
    nz-button
    [nzType]="activePeriod === 'months' ? 'primary' : 'default'"
    (click)="setActivePeriod('months')"
  >
    по месяцам
  </button>
</div>
<div style="position: relative; height: 300px; width: 100%">
  <canvas id="parkingChart"></canvas>
</div>
